import { render, staticRenderFns } from "./LessonTagChips.vue?vue&type=template&id=5ac4d73b&scoped=true"
import script from "./LessonTagChips.vue?vue&type=script&lang=js"
export * from "./LessonTagChips.vue?vue&type=script&lang=js"
import style0 from "./LessonTagChips.vue?vue&type=style&index=0&id=5ac4d73b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac4d73b",
  null
  
)

export default component.exports